<div *ngIf="loaderService.loading$ | async" class="overlay">
    <div class="spinner"></div>
    <!-- <i class="pi pi-spinner-dotted fs-1"></i> -->
</div>